import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
// TODO : remove @angular/material dependency
import { MatSnackBar } from '@angular/material';
import {
  ShowInfoMessage,
  NotificationActionTypes,
  ShowErrorMessage,
  ShowWarningMessage,
  ShowMessage,
  ShowTraceableMessage,
  OnMessageAction,
  AfterMessageDismissed
} from './notification.actions';
import { map, switchMap } from 'rxjs/operators';
import { merge, race, Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NotificationEffects {
  @Effect({ resubscribeOnError: true })
  public showErrorMessage$ = this.actions$.pipe(
    ofType<ShowErrorMessage>(NotificationActionTypes.ShowErrorMessage),
    switchMap(action =>
      this.translate
        .get(action.message)
        .pipe(map(message => ({ ...action, message })))
    ),
    map(
      action =>
        new ShowMessage(action.message, 'OK', {
          duration: 25000,
          panelClass: 'error-message'
        })
    )
  );

  @Effect({ resubscribeOnError: true })
  public showInfoMessage$ = this.actions$.pipe(
    ofType<ShowInfoMessage>(NotificationActionTypes.ShowInfoMessage),
    switchMap(action =>
      this.translate
        .get(action.message)
        .pipe(map(message => ({ ...action, message })))
    ),
    map(
      action =>
        new ShowMessage(action.message, 'OK', {
          duration: 10000,
          panelClass: 'info-message'
        })
    )
  );

  @Effect({ resubscribeOnError: true })
  public showWarningMessage$ = this.actions$.pipe(
    ofType<ShowWarningMessage>(NotificationActionTypes.ShowWarningMessage),
    switchMap(action =>
      this.translate
        .get(action.message)
        .pipe(map(message => ({ ...action, message })))
    ),
    map(
      action =>
        new ShowMessage(action.message, 'OK', {
          duration: 12000,
          panelClass: 'warn-message'
        })
    )
  );

  @Effect({ dispatch: false, resubscribeOnError: true })
  public showMessage$ = this.actions$.pipe(
    ofType<ShowMessage>(NotificationActionTypes.ShowMessage),
    switchMap(action =>
      this.translate
        .get(action.message)
        .pipe(map(message => ({ ...action, message })))
    ),
    map(action =>
      this.snackBar.open(action.message, action.action, action.config)
    )
  );

  @Effect({ resubscribeOnError: true })
  public showTraceableMessage$ = this.actions$.pipe(
    ofType<ShowTraceableMessage>(NotificationActionTypes.ShowTraceableMessage),
    switchMap(action =>
      this.translate
        .get(action.message)
        .pipe(map(message => ({ ...action, message })))
    ),
    switchMap(action => {
      const ref = this.snackBar.open(
        action.message,
        action.action,
        action.config
      );
      return race(
        ref
          .onAction()
          .pipe(map(() => new OnMessageAction(action.tracer) as Action)),
        ref
          .afterDismissed()
          .pipe(map(() => new AfterMessageDismissed(action.tracer) as Action))
      );
    })
  );

  constructor(
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}
}
